/**
 * URL patterns Sentry should ignore when deciding whether to report an error.
 *
 * Sentry evaluates `denyUrls` against each frame's URL in the stack trace —
 * an event is dropped when any frame URL matches any entry in the list.
 */
export const sentryDenyUrls: RegExp[] = [
  // Filter out noise from Facebook's in-app browser (IAB). When the IAB
  // closes, Facebook's injected navigation_performance_logger_android
  // script fires a teardown handler after the Java bridge has already been
  // released, causing an unhandled "Java object is gone" error that
  // originates entirely within Facebook's own injected code (iabjs://
  // scheme) and does not reflect any issue in our application.
  /^iabjs:\/\//,
  // Filter out errors originating from browser extensions. These errors
  // are thrown inside the extension's own sandboxed scripts (e.g.
  // chrome-extension:// or moz-extension://) and are not caused by our
  // application code. They appear when third-party extensions (crypto
  // wallets, ad-blockers, etc.) interact with pages they are injected
  // into, and produce false-positive noise in our Sentry queue.
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
];
